import { useReducedMotion } from "framer-motion";

// Vertical tech-scrolling rail: a slow looping column of device labels that
// light up on hover. Edge-masked top/bottom. Pauses on hover, static when
// reduced motion is on. items: [{ label, img? }]
export const TechRail = ({ items, className = "", speed = 26, testid }) => {
  const reduce = useReducedMotion();
  const doubled = [...items, ...items];
  return (
    <div
      data-testid={testid}
      aria-hidden="true"
      className={`tech-rail select-none overflow-hidden ${className}`}
    >
      <div
        className={`flex flex-col gap-6 ${reduce ? "" : "rail-scroll"}`}
        style={reduce ? undefined : { animationDuration: `${speed}s` }}
      >
        {doubled.map((it, i) => (
          <div key={`${it.label}-${i}`} className="rail-item flex items-center gap-3">
            <span className="w-6 text-end font-mono text-[9px] text-accent-soft/80">
              {String((i % items.length) + 1).padStart(2, "0")}
            </span>
            {it.img && (
              <img
                src={it.img}
                alt=""
                loading="lazy"
                decoding="async"
                className="h-9 w-9 object-contain drop-shadow-[0_0_10px_rgba(79,179,191,0.35)]"
              />
            )}
            <span className="rail-label whitespace-nowrap font-mono text-[11px] uppercase tracking-[0.24em] text-ink/50">
              {it.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
